//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTableMenu', {
//        templateUrl: 'views/components/views/metaTableMenu/metaTableMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'metaTableMenuService', 'metaTableService', function ($stateParams, metaTableMenuService, metaTableService) {
//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            vm.model = {
//                menu: {},
//                selectListRelatedTo: []
//            };

//            async function loadMenu() {
//                vm.model.menu = (await metaTableMenuService.getMetaTableMenu({ metatable_keyno: metaTableKeyno }))[0];
//            }

//            async function loadRelatedToMetaTables() {
//                vm.model.selectListRelatedTo = await metaTableService.listRelatedToMetaTables();
//            }
            
//            vm.$onInit = function () {
//                loadMenu();
//                loadRelatedToMetaTables();
//            }
//        }]
//    });
//})();
